import { Epic } from 'redux-observable';
import { from } from 'rxjs';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { AppViewServiceImpl } from '../services';
import {
  appViewFetchUserFailed,
  appViewFetchUserRequest,
  appViewFetchUserSuccess,
} from '../appViewSlice';
import { RootState } from '../../../store';

type IN = ReturnType<typeof appViewFetchUserRequest>;
type OUT =
  | ReturnType<typeof appViewFetchUserSuccess>
  | ReturnType<typeof appViewFetchUserFailed>;

export const LoginViewOnLoginEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(appViewFetchUserRequest.match),
    withLatestFrom(state$),
    switchMap(([{ payload: accessToken }, state]) => {
      if (!accessToken)
        return [
          appViewFetchUserFailed({ msg: 'Failed to obtain access token' }),
        ];

      return from(
        AppViewServiceImpl.getUser(accessToken)
          .then((data) => appViewFetchUserSuccess(data))
          .catch((error) => {
            console.error(error);
            return appViewFetchUserFailed({
              msg: 'Failed to fetch user',
            });
          }),
      );
    }),
  );
